import {useMemo} from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {MaxWidthContainer} from '@/components/Layout';
import PageHeaderMedia from '@/components/PageHeaderMedia/PageHeaderMedia';
import appContent from '@/services/content/appContent';
import {twx} from '@/utils/tailwindUtils';

const useNotificationTurnOnPhonePopup = () =>
    useMemo(() => appContent.getNotificationTurnOnPhonePopupByPlatform() || {}, []);

const ResetNotificationPermissionsModalContent = ({children, headerId}) => {
    const {page, items} = useNotificationTurnOnPhonePopup();
    const {title, description, image, video} = page || {};
    const isMediaAvailable = video || !!image?.length;

    return (
        <div className='flex w-full flex-1 flex-col items-center'>
            {isMediaAvailable && (
                <PageHeaderMedia
                    isVideoAvailable={!!video?.thumbnailPath}
                    videoThumbnailSrc={video?.thumbnailPath}
                    videoSrc={video?.path}
                    imageMedia={image}
                    className='md:mt-8'
                />
            )}
            <MaxWidthContainer className='mb-4 flex-1 justify-end px-4 md:mt-4 ml:mb-0 ml:justify-normal'>
                {title && (
                    <h1 id={headerId} className='mb-0 mt-4 text-28'>
                        {title}
                    </h1>
                )}
                {description && <p className='mt-2'>{description}</p>}
                {items?.length > 0 && (
                    <ul className='mt-4 flex w-full flex-col gap-2 rounded-xl bg-primary-dark-5 p-4'>
                        {items?.map((icon, i) => {
                            const {title, path} = icon;

                            if (!title) return null;

                            return (
                                <li key={i} className='flex items-center justify-start gap-2'>
                                    <div className='min-w-8 shrink-0'>
                                        <RemoteIconV2 icon={{path}} />
                                    </div>
                                    <span className='text-start text-14'>{title}</span>
                                </li>
                            );
                        })}
                    </ul>
                )}
                {children}
            </MaxWidthContainer>
        </div>
    );
};

const SaveButton = ({className, onClick}) => {
    const {button} = useNotificationTurnOnPhonePopup();
    const {text, alt} = button || {};

    return (
        <AppButton className={twx('m-auto ml:w-full', className)} primary light aria-label={alt} onClick={onClick}>
            {text}
        </AppButton>
    );
};

ResetNotificationPermissionsModalContent.SaveButton = SaveButton;

export default ResetNotificationPermissionsModalContent;
